<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-comments</v-icon>
        <h1 class="title ml-2">Comentarios y sugerencias</h1>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :items="sugerencias"
          :headers="headers"
          hide-default-footer
          items-per-page="25"
        >
          <template v-slot:item.opciones="{ item }">
            <v-btn small tile color="primary" icon @click="showItem(item.id)">
              <v-icon>fas fa-list</v-icon>
            </v-btn>
            <v-btn small tile color="error" icon @click="deleteItem(item.id)" class="ml-2">
              <v-icon>fas fa-trash</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="pages"
        ></v-pagination>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogShow" max-width="600px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon>fas fa-comments</v-icon>
          <span class="title ml-2">Comentario</span>
        </v-card-title>
        <v-card-text>
          <p class="mt-4"><strong>Nombre: </strong>{{ selected.nombre }}</p>
          <p><strong>Teléfono: </strong>{{ selected.telefono }}</p>
          <p><strong>E-mail: </strong>{{ selected.email }}</p>
          <p><strong>Fecha: </strong>{{ selected.fecha }}</p>
          <p class="font-weight-bold">Mensaje:</p>
          <p>{{selected.mensaje}}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="dialogShow = false">
            <v-icon left>fas fa-times</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import dayjs from 'dayjs'
export default {
  data () {
    return {
      dialogShow: false,
      sugerencias: [],
      page: 1,
      pages: 1,
      headers: [
        { text: 'Nombre', value: 'nombre', sortable: true },
        { text: 'Telefono', value: 'telefono', sortable: true },
        { text: 'E-mail', value: 'email', sortable: true },
        { text: 'Mensaje', value: 'mensaje', sortable: false, width: '250px' },
        { text: 'Fecha', value: 'fecha', sortable: true },
        { text: 'Opciones', value: 'opciones', sortable: false }
      ],
      selected: {
        nombre: '',
        telefono: '',
        email: '',
        mensaje: '',
        fecha: ''
      }
    }
  },
  async created () {
    await this.getPages()
    await this.getSugerencias()
  },
  methods: {
    async getPages () {
      const { data } = await this.$http.sugerencias.get('/count')
      this.pages = Math.ceil(data / 25)
    },
    async getSugerencias () {
      const skip = (this.page - 1) * 25
      const { data } = await this.$http.sugerencias.get(`?_sort=createdAt:ASC&_limit=25&_start=${skip}`)
      this.sugerencias = data.map(i => {
        return {
          ...i,
          mensaje: `${i.mensaje.substring(0, 1000)}...`,
          fecha: dayjs(i.createdAt).format('DD-MM-YYYY')
        }
      })
    },
    showItem (id) {
      this.selected = this.sugerencias.find(i => i.id === id)
      this.dialogShow = true
    },
    async deleteItem (id) {
      if (window.confirm('¿Estas seguro de borrar el comentario/sugerencia?')) {
        await this.$http.sugerencias.delete(`/${id}`)
        this.getSugerencias()
      }
    }
  },
  watch: {
    page () {
      this.getSugerencias()
    }
  }
}
</script>
